import { useEffect } from 'react';
import firebaseService from '../firebase/firebaseService';
import { postAnonymousAnalytics } from '../api/studio';

const LANDING_PARAM = 'from';
const LANDING_VALUE = 'artist_landing_page';

export default function useLandingRedirect() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const fromValue = params.get(LANDING_PARAM);

    if (fromValue !== LANDING_VALUE) return;

    params.delete(LANDING_PARAM);
    const newSearch = params.toString();
    window.history.replaceState(
      null,
      '',
      window.location.pathname +
        (newSearch ? `?${newSearch}` : '') +
        window.location.hash,
    );

    const unsubscribe = firebaseService.onAuthStateChanged((user) => {
      if (!user) {
        postAnonymousAnalytics({
          type: 'clicked_become_artist',
          context: fromValue,
        }).catch(console.error);
      }
      unsubscribe();
    });

    return () => unsubscribe();
  }, []);
}
